import React, { useState,useMemo, useEffect, useRef } from 'react';
import Container from '@material-ui/core/Container';
import {TextField, Button, Modal, Box} from '@material-ui/core/';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { withStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import InputMask from 'react-input-mask';
import { DataGrid,GridToolbarContainer,useGridApiRef,ptBR  } from '@mui/x-data-grid';

import {useStyles} from "./styles";
import ContatoRapido from "../../../components/ContatoRapido";
import Autocomplete from '@material-ui/lab/Autocomplete';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import AddIcon from '@material-ui/icons/Add';
import {randomId} from '@mui/x-data-grid-generator';
import {Redirect, useParams, Prompt} from "react-router-dom";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Paper from '@material-ui/core/Paper';
import PageHeader from '../../../components/PageHeader';
import StatusChip from '../../../components/StatusChip';
import moment from "moment"
import RelatorioLeadModal from "../../relatorioLead/index";
import RelatorioLeadTable from "../../relatorioLead/Table";
import api from '../../../services/api';
import { pode } from '../../../services/acesso';
import { toast  } from 'react-toastify';
import { useHistory } from "react-router-dom";
import CurrencyInput from "../../../components/CurrencyInput";
import paisesJson from './paises.json'
import HistoricoAgendamentos from "../../../components/HistoricoAgendamentos";

function RowMenuCell(props) {
    const { api, id } = props;
    const classes = useStyles();

    const handleDeleteClick = (event) => {
      event.stopPropagation();
      console.log(event)
      api.updateRows([{ id, _action: 'delete' }]);
    };

    return (
      <div className={classes.root}>
        <IconButton
          size="small"
          aria-label="delete"
          onClick={handleDeleteClick}
        >
          <DeleteIcon fontSize="small" />
        </IconButton>
      </div>
    );
}



const columnsResponsible = [
    { field: 'name', headerName: 'Nome', width: 300, editable: true},
    {
        field: 'contato_rapido',
        headerName: 'Contato',
        width: 210,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        renderCell: (params) => (
            <ContatoRapido
                telefone={params.row.telephone}
                email={params.row.email}
                linkedin={params.row.linkedin}
                mostrarNumero={false}
                quebrarLinha={false}
            />
        ),
    },
    { field: 'email', headerName: 'E-mail', width: 200, editable: true },
    { field: 'telephone', headerName: 'Telefone', width: 150, editable: true },
    { field: 'linkedin', headerName: 'Linkedin', width: 150, editable: true },
    { field: 'cargo', headerName: 'Cargo', width: 150, editable: true },
    {
        field: 'actions',
        headerName: 'Ações',
        renderCell: RowMenuCell,
        sortable: false,
        width: 100,
        headerAlign: 'center',
        filterable: false,
        align: 'center',
        disableColumnMenu: true,
        disableReorder: true,
      },
];


function useApiRef() {
    const apiRef = useGridApiRef();
    const _columns = useMemo(
      () => columnsResponsible.concat({
          field: "__HIDDEN__",
          width: 0,
          renderCell: (params) => {
            apiRef.current = params.api;
            return "";
          }
        }),
      [columnsResponsible]
    );

    return { apiRef, columnsResponsible: _columns };
}



const GreenCheckbox = withStyles({
    root: {
      color: green[400],
      '&$checked': {
        color: green[600],
      },
    },
    checked: {},
  })((props) => <Checkbox color="default" {...props} />);

const FormCustomer = (props) => {

    function EditToolbar(props) {
        const { apiRef, labelButton  } = props;
        const handleClick = () => {
          const id_row = "new_"+randomId();
        //   apiRef.current.updateRows([{ id, isNew: true }]);

        let rowsArr = [];

        try {
            if(apiRef.current.getRowModels){
                let rows = apiRef.current.getRowModels();
                rows.forEach((row) =>{
                    rowsArr.push(row)
                })
            }
        } catch (error) {

        }



        rowsArr.push({ id:id_row })

        setResponsibles(rowsArr)
    };

        return (
          <GridToolbarContainer>
            <Button id="button_1" color="primary" startIcon={<AddIcon />} onClick={handleClick}>
              {labelButton}
            </Button>
          </GridToolbarContainer>
        );
    }

    const classes = useStyles();
    let { id, id_mailing } = useParams();

    const [active,setActive] = useState(false)
    const [name,setName] = useState("")

    const [corporateName,setCorporateName] = useState("")

    const [cnpj,setCnpj] = useState("")
    const [cep,setCep] = useState("")
    const [logradouro,setLogradouro] = useState("")
    const [neighborhood,setNeighborhood] = useState("")
    const [number,setNumber] = useState("")
    const [complement,setComplement] = useState("")
    const [city,setCity] = useState("")
    const [state,setState] = useState({sigla: null,nome: ""})

    const [pais,setPais] = useState({value: null})
    const [paises, setPaises] = useState(paisesJson);

    const [telephone,setTelephone] = useState("")
    const [responsibles,setResponsibles] = useState([])
    const [numberEmployees,setNumberEmployees] = useState([])
    const [site,setSite] = useState("")
    const [countResponsibles, setCountResponsibles] = React.useState(0);

    const [summary_contact,setSummaryContact] = useState("")

    const [statusSelected, setStatusSelected] = useState([]);
    const [followup, setFollowup] = useState(moment().toDate());
    const [revenues, setRevenues] = useState("0.00");

    const [users,setUsers] = useState([])

    const [cnae, setCnae] = useState("")
    const [assessores, setAssessores] = useState([]);
    const [assessorSelect, setAssessorSelect] = useState(true);
    const history = useHistory();
    const { apiRef, columnsResponsible } = useApiRef();

    const [mask, setMask] = useState('*********************');
    const [salvando, setSalvando] = useState(false);
    const [salvoEm, setSalvoEm] = useState(null);
    const [errosCampos, setErrosCampos] = useState({});


    const status = [
        {
            "id": 1,
            "name":"Em andamento"
        },
        {
            "id": 2,
            "name":"Retorno futuro"
        },
        {
            "id": 3,
            "name":"Aguardando retorno"
        },
        {
            "id": 4,
            "name":"Sem interesse"
        },
        {
            "id": 5,
            "name":"Sem perfil"
        },
        {
            "id": 6,
            "name":"Black list"
        },
        {
            "id": 7,
            "name":"Reunião agendada"
        },
    ]

    const queryParams = new URLSearchParams(window.location.search);
    const [mailing_leads_id, setMailingLeadsId] = useState();



    //resumos leads
    const [resumosLeads, setResumosLeads] = useState([]);
    const [mailings, setMailings] = useState([]);
    const [mailingsSelected, setMailingsSelected] = useState([]);
    const [cnaesSelected, setCnaesSelected] = useState([]);
    const [cnaes, setCnaes] = useState([])


    useEffect(() => {
        (async () => {
          const result = await api.get("cnae/listing");
          let data = result.data;
          setCnaes(data);
        })();
    }, []);

    const handleMailings = (value) => {
        setMailingsSelected(value)
    };

    useEffect(() => {
        if(queryParams.get('mailing_leads_id') && queryParams.get('mailing_leads_id') !== "null" ){
            setMailingLeadsId(queryParams.get('mailing_leads_id') !== "null" ? queryParams.get('mailing_leads_id') : null)
        }
    }, []);

    useEffect(() => {
        (async () => {
            const result = await api.get(`mailings`,{
              params: {}
            });
            let data = result.data.data;
            console.log("mailings",data)
            setMailings(data)
        })()
    },[])


    //const [novosResumosLead, setNovosResumosLead] = React.useState([]);

    const salvarResumo = (resumo, data = null, followUp = null, responsible = null, terceirizacao = null, databid = null) => {
        setResumosLeads([{
            id: "new_" + Date.now(),
            resumo: resumo,
            data: data,
            assessor: "",
            follow_up: followUp,
            responsible_id: responsible.id,
            responsible: responsible,
            terceirizacao: terceirizacao.id,
            data_bid: databid,
            mailing_leads_id: mailing_leads_id,
        },...resumosLeads]);
    }

    const deleteResumo = (id) => {
        setResumosLeads(resumosLeads.filter(resumo => {
            if(resumo.id != id) {
                return resumo;
            }
        }));
    }

    useEffect(() => {
        (async () => {
            try {
                const result = await api.get("assessores");
                let data = result.data?.data;
                setAssessores(data);
            } catch (e) {
                const response = e.response ? e.response : {};
                const data = response.data ? response.data : {};
                const msg = data.message ? data.message : "Ocorreu um erro ao capturar os dados do mailing";
                toast.error(msg)
            }
        })();
    }, []);

    useEffect(() => {
        if(!id) {
            return;
        }
        (async () => {
            try {
                const result = await api.get(`lead/${id}?mailing_leads_id=${queryParams.get('mailing_leads_id') !== "null" ? queryParams.get('mailing_leads_id') : null}`);
                let data = result.data;
                let statusSel = status.filter(statu => {
                    if(statu.id == data.status) {
                        return statu;
                    }
                })[0];
                let ufsSel = UFS.filter(uf => {
                    if(uf.sigla == data.state) {
                        return uf;
                    }
                })[0];
                if(data.responsible) {
                    setResponsibles(data.responsible);
                }
                if(data.relatorios) {
                    setResumosLeads(data.relatorios);
                }
                if(data.assessor_id) {
                    const result = await api.get("assessor/"+data.assessor_id);
                    setAssessorSelect(result.data);
                }
                setActive(data.ativo);
                setCorporateName(data.corporate_name);

                setCep(data.zip_code);
                setLogradouro(data.logradouro ? data.logradouro : "");
                setNumber(data.number ? data.number : "");
                setComplement(data.complement ? data.complement : "");
                setCity(data.city);



                let paisSelecionado = await paisesJson.filter(valor => {
                    if(valor.value == data.pais) {
                        console.log("pais",valor.value)
                        return valor;
                    }
                })[0];

                // let paisJson = {"nome":`${data.pais}`,"value":`${data.pais}`}
                setPais(paisSelecionado);

                if(ufsSel) {
                    setState(ufsSel);
                }else if(data.state){
                    setState({"nome":data.state,"sigla":data.state});
                }

                setCnae(data.cnae);

                setCnpj(data.cnpj);

                if(data.cnpj.length == 14){
                    setMask('99.999.999/9999-99');
                }

                setRevenues(data.revenues);
                setNumberEmployees(data.number_employees);
                setSite(data.site);
                setStatusSelected(statusSel);
                setSummaryContact(data.contact_summary);
                setTelephone(data.telephone);
                setCep(data.zip_code);
                setNeighborhood(data.neighborhood);
                setMailingsSelected(data.mailings)
                setCnaesSelected(data.cnae_detalhe)
                // marca o estado carregado como "salvo" (base para o aviso de alterações não salvas)
                setMarcarBase(true)

                // fetch(`https://viacep.com.br/ws/${cep}/json/`)
                // .then((res) => res.json())
                // .then((data) => {

                //     if(data.erro && data.erro == true){
                //         return false;
                //     }

                //     setLogradouro(data.logradouro)
                //     setNeighborhood(data.bairro)
                //     setCity(data.localidade)
                // });

            }catch(e) {
                const response = e.response ? e.response : {};
                const data = response.data ? response.data : {};
                const msg = data.message ? data.message : "Ocorreu um erro ao capturar os dados do mailing";
                toast.error(msg)
            }
        })();
    }, []);

    const UFS =  [
        {"nome": "Acre", "sigla": "AC"},
        {"nome": "Alagoas", "sigla": "AL"},
        {"nome": "Amapá", "sigla": "AP"},
        {"nome": "Amazonas", "sigla": "AM"},
        {"nome": "Bahia", "sigla": "BA"},
        {"nome": "Ceará", "sigla": "CE"},
        {"nome": "Distrito Federal", "sigla": "DF"},
        {"nome": "Espírito Santo", "sigla": "ES"},
        {"nome": "Goiás", "sigla": "GO"},
        {"nome": "Maranhão", "sigla": "MA"},
        {"nome": "Mato Grosso", "sigla": "MT"},
        {"nome": "Mato Grosso do Sul", "sigla": "MS"},
        {"nome": "Minas Gerais", "sigla": "MG"},
        {"nome": "Pará", "sigla": "PA"},
        {"nome": "Paraíba", "sigla": "PB"},
        {"nome": "Paraná", "sigla": "PR"},
        {"nome": "Pernambuco", "sigla": "PE"},
        {"nome": "Piauí", "sigla": "PI"},
        {"nome": "Rio de Janeiro", "sigla": "RJ"},
        {"nome": "Rio Grande do Norte", "sigla": "RN"},
        {"nome": "Rio Grande do Sul", "sigla": "RS"},
        {"nome": "Rondônia", "sigla": "RO"},
        {"nome": "Roraima", "sigla": "RR"},
        {"nome": "Santa Catarina", "sigla": "SC"},
        {"nome": "São Paulo", "sigla": "SP"},
        {"nome": "Sergipe", "sigla": "SE"},
        {"nome": "Tocantins", "sigla": "TO"}
    ];

    const handleActive = (event) => {
        setActive(event.target.checked)
    };


    const handleCorporateName = (event) => {
        setCorporateName(event.target.value)
    };


    const handleCNAE = (event) => {
        setCnae(event.target.value)
    };

    function realParaNumber(texto){
        var compativelComParseFloat = texto.replace("R$ ","");
        compativelComParseFloat = compativelComParseFloat.replaceAll(".","");
        // compativelComParseFloat = compativelComParseFloat.replace(".","");
        // compativelComParseFloat = compativelComParseFloat.replace(".","");
        compativelComParseFloat = compativelComParseFloat.replace(",",".");
        // var valor = parseFloat(compativelComParseFloat);
        return compativelComParseFloat;
    }

    const handleRevenues = (event, value, maskedValue) => {
        var currency = event.target.value;

        var number = realParaNumber(currency)

        setRevenues(number)
    };

    const handleNumberEmployees = (event) => {
        setNumberEmployees(event.target.value)
    };

    const handleSite = (event) => {
        setSite(event.target.value)
    };

    const handleCnpj = (event) => {
        let value = event.target.value
        if (value.length !== 14) {
            setMask('************************');
          } else {
            setMask('99.999.999/9999-99');
          }

        setCnpj(value.replace(/[^0-9]/g, ''))
    };

    const handleCep = (event) => {
        let cep = event.target.value.replace(/[^0-9]/g, '')

        setCep(cep)


        if(cep.length === 8){
            fetch(`https://viacep.com.br/ws/${cep}/json/`)
            .then((res) => res.json())
            .then((data) => {

                if(data.erro && data.erro == true){
                    return false;
                }

                setLogradouro(data.logradouro ? data.logradouro : "")
                setNeighborhood(data.bairro ? data.bairro : "")
                setCity(data.localidade ? data.localidade : "")

                setNumber("")

                let state = {sigla: null,nome: ""}
                UFS.map((uf)=>{
                    if(uf.sigla == data.uf){
                        state = uf

                    }
                })

                setState(state)


            }).catch(() =>{
                toast.warning("Não foi possível consultar o CEP. Preencha o endereço manualmente.")
            });
        }

    };

    const handleLogradouro = (event) => {
        setLogradouro(event.target.value)
    };

    const handleNumber = (event) => {
        setNumber(event.target.value.replace(/[^0-9]/g, ''))
    };

    const handleComplement = (event) => {
        setComplement(event.target.value)
    };

    const handlePais = (value) => {
        setState({sigla:null,nome:""})
        setPais(value)
    }

    const handleNeighborhood = (event) => {
        setNeighborhood(event.target.value)
    }

    const handleSummaryContact = (event) => {
        setSummaryContact(event.target.value)
    };


    const handleCity = (event) => {
        setCity(event.target.value)
    };

    const handleState = (value) => {
        if(value) {
            setState(value)
        }else{
            setState({sigla: null})
        }

    };

    const handleTelephone = (event) => {
        let tel = event.target.value.replace(/[^0-9]/g, '')
        setTelephone(tel)
    }

    const handleFollowup = (value) => {
        setFollowup(value)
    }



    const handleStatusSelected = (value) => {
        setStatusSelected(value);
    };




    const handleSave = async () => {
        let contacts = []
        try {
            if(apiRef.current) {
                contacts = apiRef.current.getRowModels();
            }
        } catch (error) {

        }

        let contactsArr = [];
        contacts.forEach((contact) =>{
            contactsArr.push(contact)
        })
        // Proteção: se a grade de decisores não puder ser lida, usa a lista carregada
        // (enviar uma lista vazia apagaria os decisores no backend).
        if (contactsArr.length === 0 && Array.isArray(responsibles) && responsibles.length > 0) {
            contactsArr = responsibles.slice();
        }


        let mailings = [];
        mailingsSelected.forEach((mailing) =>{
            mailings.push(mailing.id)
        })


        // Valida antes de enviar (antes os avisos apareciam e o lead era enviado mesmo assim).
        const erros = {};
        if(!corporateName) erros.corporateName = "Informe a razão social";
        if(!cnpj) erros.cnpj = "Informe o CNPJ";
        if(!cnaesSelected?.cnae) erros.cnae = "Selecione o CNAE";
        setErrosCampos(erros);
        if (Object.keys(erros).length > 0) {
            toast.error("Preencha os campos obrigatórios destacados em vermelho.");
            window.scrollTo({ top: 0, behavior: "smooth" });
            return;
        }

        let data = {
            ativo: active,
            corporate_name: corporateName,
            zip_code: cep,
            logradouro,
            number,
            complement,
            city,
            state: state?.sigla,
            pais: pais?.value,
            responsible: contactsArr,
            cnae: cnaesSelected?.cnae,
            cnpj,
            neighborhood: neighborhood,
            revenues: revenues,
            number_employees: numberEmployees,
            site: site,
            telephone: telephone,
            date_followup: followup,
            mailing_id: id_mailing,
            contact_summary: summary_contact,
            relatorios: resumosLeads,
            mailings: mailings
        };

        setSalvando(true);
        try {
            let data_lead = null;
            if(id) {
                data_lead = await api.patch(`lead/${id}/save`, data);
                toast.success("Lead atualizado com sucesso");
            }
            else {
                data_lead = await api.post("lead/save", data);
                toast.success("Lead criado com sucesso");
            }
            setSalvoEm(moment().format("HH:mm"));
            setMarcarBase(true);
        } catch(e) {
            console.log(e);
            const response = e.response ? e.response : {};
            const data = response.data ? response.data : {};
            const msg = data.message ? data.message : "Ocorreu um erro ao salvar o Lead";
            toast.error(msg)
        } finally {
            setSalvando(false);
        }
    };

    const handleNovaReuniao =  () => {
        history.push("/agendamento-lead/novo?id_lead="+id);
    }

    const currencyConfig = {
        locale: "pt-BR",
        formats: {
          number: {
            BRL: {
              style: "currency",
              currency: "BRL",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            },
          },
        },
      };

    /* Alterações não salvas -------------------------------------------- */
    const [aba, setAba] = useState(0);
    const [marcarBase, setMarcarBase] = useState(!id);
    const base = useRef(null);
    const retrato = JSON.stringify([active, corporateName, cnpj, cep, logradouro, neighborhood, number, complement, city,
        state && state.sigla, state && state.nome, pais && pais.value, telephone, numberEmployees, site, revenues,
        (mailingsSelected || []).map((m) => m && m.id), cnaesSelected && cnaesSelected.cnae, (resumosLeads || []).length,
        (responsibles || []).length]);
    useEffect(() => {
        if (marcarBase) {
            base.current = retrato;
            setMarcarBase(false);
        }
    }, [marcarBase, retrato]);
    const alterado = base.current !== null && base.current !== retrato;

    useEffect(() => {
        const aviso = (e) => {
            if (!alterado) return undefined;
            e.preventDefault();
            e.returnValue = "";
            return "";
        };
        window.addEventListener("beforeunload", aviso);
        return () => window.removeEventListener("beforeunload", aviso);
    }, [alterado]);

    // Painéis ocultos ficam montados (fora da tela) para não perder o que foi digitado,
    // em especial a grade de decisores, que guarda as edições internamente.
    const painel = (indice) => (aba === indice
        ? { position: "relative" }
        : { position: "absolute", left: -99999, top: 0, width: "100%", visibility: "hidden" });

    const ultimoResumo = Array.isArray(resumosLeads) && resumosLeads.length > 0 ? resumosLeads[0] : null;
    const tituloSecao = { margin: "0 0 14px", fontSize: 12, fontWeight: 600, letterSpacing: ".04em", textTransform: "uppercase", color: "#56604F" };

    return (
            <Container fixed>
                <Prompt when={alterado} message="Há alterações não salvas neste lead. Sair mesmo assim?" />
                <PageHeader
                    fixo
                    trilha={[{ texto: "Leads", para: "/leads" }, { texto: !id ? "Novo lead" : (corporateName || "Editar lead") }]}
                    titulo={!id ? "Novo lead" : (corporateName || "Editar lead")}
                    selo={statusSelected && statusSelected.id ? <StatusChip tipo="lead" valor={statusSelected.id} /> : null}
                    acoes={
                        <>
                            {alterado
                                ? <span style={{ fontSize: 13, color: "#9A6100", fontWeight: 600 }}>Alterações não salvas</span>
                                : (salvoEm && <span style={{ fontSize: 13, color: "#56604F" }}>Salvo às {salvoEm}</span>)}
                            {id && pode("editar_reunioes") && (
                                <Button id="nova_reuniao" variant="outlined" onClick={handleNovaReuniao}>
                                    Nova reunião
                                </Button>
                            )}
                            {pode("editar_leads") && (
                                <Button id="salvar_form" variant="contained" color="primary" onClick={handleSave} disabled={salvando}>
                                    {salvando ? "Salvando..." : "Salvar"}
                                </Button>
                            )}
                        </>
                    }
                >
                    <Tabs value={aba} onChange={(e, v) => setAba(v)} indicatorColor="primary" textColor="primary" variant="scrollable" scrollButtons="auto" aria-label="Seções do lead">
                        <Tab label="Empresa" id="aba-0" aria-controls="painel-0" />
                        <Tab label={`Decisores (${(responsibles || []).length})`} id="aba-1" aria-controls="painel-1" />
                        <Tab label={`Contatos e resumos (${(resumosLeads || []).length})`} id="aba-2" aria-controls="painel-2" />
                        {id && <Tab label="Reuniões" id="aba-3" aria-controls="painel-3" />}
                    </Tabs>
                </PageHeader>
                <form noValidate autoComplete="off" style={{ position: "relative" }}>
                  <div role="tabpanel" id="painel-0" aria-labelledby="aba-0" style={painel(0)}>
                   <Grid container spacing={2}>
                    <Grid item xs={12} md={8}>
                    <Paper variant="outlined" style={{ padding: "18px 20px", marginBottom: 16 }}>
                    <h2 style={tituloSecao}>Dados da empresa</h2>
                    <Grid xs={12}>
                        <FormControlLabel
                            control={<GreenCheckbox checked={active} onChange={handleActive} name="active" />}
                            label="Ativo"
                        />
                    </Grid>
                    <Grid container spacing={2} style={{ marginBottom: 8 }}>


                        <Grid item xs={12} sm={6} md={6}>
                            <TextField required id="razao_social" label="Razão social" value={corporateName} onChange={handleCorporateName} error={!!errosCampos.corporateName} helperText={errosCampos.corporateName} fullWidth />
                        </Grid>
                        <Grid item xs={12} sm={6} md={2}>
                            <InputMask mask={mask} value={cnpj} onChange={handleCnpj}>
                                {(inputProps) => <TextField {...inputProps} required id="cnpj" label="CNPJ" error={!!errosCampos.cnpj} helperText={errosCampos.cnpj} fullWidth />}
                            </InputMask>
                        </Grid>
                        <Grid item xs={12} sm={6} md={2}>
                            {/* <TextField required id="standard-required" type={"number"}  label="Faturamento" value={revenues} onChange={handleRevenues} fullWidth /> */}
                            {/* <IntlCurrencyInput label="Faturamento" currency="BRL" config={currencyConfig}
            o               nChange={handleRevenues} /> */}
                            {/* <InputMask mask="+4" value={cnpj} onChange={handleRevenues}>
                                {(inputProps) => <TextField {...inputProps} required  label="Faturamento" />}
                            </InputMask> */}
                            <label htmlFor="faturamento" style={{ display: "block", fontSize: 12, color: "#56604F" }}>Faturamento (R$)</label>
                            <CurrencyInput id="faturamento" placeholder="R$ 0,00" type="text" value={revenues} onChange={handleRevenues} />

                            {/* <CurrencyInput placeholder="$0.00" type="text" >
                                {(inputProps) => <TextField {...inputProps} required  label="CNPJ" />}
                            </CurrencyInput> */}
                        </Grid>
                        <Grid item xs={12} sm={6} md={2}>
                            <TextField id="numero_funcionarios" type={"number"} inputProps={{ min: 0 }} label="Nº de funcionários" value={numberEmployees} onChange={handleNumberEmployees} fullWidth />
                        </Grid>

                    </Grid>
                    <Grid container spacing={2} style={{ marginBottom: 8 }}>
                        <Grid item xs={12} sm={6} md={2}>
                            {/* <TextField required id="standard-required"  label="CNAE" value={cnae} onChange={handleCNAE} fullWidth />
                             */}
                            <Autocomplete
                                disablePortal
                                id="cnae"
                                options={cnaes}
                                onChange={(event, newInputValue) => {
                                    setCnaesSelected(newInputValue);
                                }}
                                value={cnaesSelected}
                                getOptionLabel={(option) => option.nome || ""}
                                renderInput={(params) => <TextField {...params} label="CNAE" required error={!!errosCampos.cnae} helperText={errosCampos.cnae} />}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={2}>
                            <TextField id="site" label="Site" placeholder="www.empresa.com.br" value={site} onChange={handleSite} fullWidth />
                        </Grid>
                        <Grid item xs={12} sm={6} md={2}>
                            <InputMask mask={String(telephone || "").length > 10 ? "(99) 99999-9999" : "(99) 9999-99999"} maskChar={null} value={telephone} onChange={handleTelephone}>
                                {(inputProps) => <TextField {...inputProps} id="telefone" label="Telefone" fullWidth />}
                            </InputMask>
                            <ContatoRapido telefone={telephone} mostrarNumero={false} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <Autocomplete
                                disablePortal
                                id="mailings"
                                multiple
                                options={mailings}
                                onChange={(event, newInputValue) => {
                                    handleMailings(newInputValue);
                                }}
                                value={mailingsSelected}
                                getOptionLabel={(option) => option.name || ""}
                                renderInput={(params) => <TextField {...params}  label="Mailing" />}
                            />
                        </Grid>
                    </Grid>
                    </Paper>
                    <Paper variant="outlined" style={{ padding: "18px 20px", marginBottom: 16 }}>
                    <h2 style={tituloSecao}>Endereço</h2>
                    <Grid container spacing={2} style={{ marginBottom: 8 }}>
                        <Grid item xs={12} sm={6} md={2}>
                            <InputMask mask={"99999-999"} value={cep} onChange={handleCep}>
                                {(inputProps) => <TextField {...inputProps} id="cep" label="CEP" fullWidth />}
                            </InputMask>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                            <TextField id="logradouro" label="Logradouro" onChange={handleLogradouro} value={logradouro} fullWidth />
                        </Grid>
                        <Grid item xs={12} sm={6} md={1}>
                            <TextField id="numero" label="Número" onChange={handleNumber} value={number} fullWidth />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <TextField id="complemento" label="Complemento" onChange={handleComplement} value={complement} fullWidth />
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} style={{ marginBottom: 8 }}>
                        <Grid item xs={12} sm={6} md={3}>
                            <TextField id="bairro" label="Bairro" onChange={handleNeighborhood} value={neighborhood} fullWidth />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <TextField id="cidade" label="Cidade" onChange={handleCity} value={city} fullWidth />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            {/* <TextField  id="standard-required" label="País" onChange={handlePais} value={pais} fullWidth /> */}
                            <Autocomplete
                            disablePortal
                            id="pais"
                            options={paises}
                            onChange={(event, newInputValue) => {
                                handlePais(newInputValue);
                            }}
                            value={pais}
                            getOptionLabel={(option) => option.nome || ""}
                            renderInput={(params) => <TextField {...params} label="País" />}
                        />
                        </Grid>
                        <Grid item xs={12} sm={6} md={2}>

                            {pais?.value == "Brasil" ? (<Autocomplete
                                disablePortal
                                id="state"
                                options={UFS}
                                onChange={(event, newInputValue) => {
                                    console.log(newInputValue)
                                handleState(newInputValue);
                                }}
                                value={state}
                                getOptionLabel={(option) => option.nome || ""}
                                renderInput={(params) => <TextField {...params} label="Estado" />}
                            />) : (<TextField id="estado" label="Estado" onChange={(event) => handleState({"nome":event.target.value, "sigla": event.target.value})} value={state.nome} fullWidth  />)
                            }

                        </Grid>

                    </Grid>

                    </Paper>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Paper variant="outlined" style={{ padding: "18px 20px" }}>
                            <h2 style={tituloSecao}>Resumo</h2>
                            <dl style={{ margin: 0, fontSize: 14, display: "grid", gap: 10 }}>
                                <div><dt style={{ fontSize: 12, color: "#56604F", fontWeight: 600 }}>Mailing</dt><dd style={{ margin: 0 }}>{(mailingsSelected || []).map((m) => m && m.name).filter(Boolean).join(", ") || "—"}</dd></div>
                                <div><dt style={{ fontSize: 12, color: "#56604F", fontWeight: 600 }}>Assessor</dt><dd style={{ margin: 0 }}>{(assessorSelect && assessorSelect.name) || "—"}</dd></div>
                                <div><dt style={{ fontSize: 12, color: "#56604F", fontWeight: 600 }}>Decisores</dt><dd style={{ margin: 0 }}>{(responsibles || []).length}</dd></div>
                                <div><dt style={{ fontSize: 12, color: "#56604F", fontWeight: 600 }}>Último contato</dt><dd style={{ margin: 0 }}>{ultimoResumo ? [ultimoResumo.data ? moment(ultimoResumo.data).format("DD/MM/YYYY") : null, ultimoResumo.resumo].filter(Boolean).join(" — ") : "—"}</dd></div>
                            </dl>
                        </Paper>
                    </Grid>
                   </Grid>
                  </div>

                  <div role="tabpanel" id="painel-1" aria-labelledby="aba-1" style={painel(1)}>
                            <DataGrid
                                autoPageSize
                                pagination
                                style={{height:500,background:"#fff"}}
                                rows={responsibles}
                                pageSize={5}
                                columns={columnsResponsible}
                                editMode="row"
                                localeText={ptBR.props.MuiDataGrid.localeText}
                                components={{
                                    Toolbar: EditToolbar,
                                }}
                                componentsProps={{
                                    toolbar: { apiRef, labelButton:"Adicionar decisor" },
                                }}
                            />
                  </div>

                  <div role="tabpanel" id="painel-2" aria-labelledby="aba-2" style={painel(2)}>
                    <Paper variant="outlined" style={{ padding: "18px 20px" }}>
                        <RelatorioLeadModal salvarResumo={salvarResumo} responsibles={responsibles} />
                        <RelatorioLeadTable deleteResumo={deleteResumo} resumos={resumosLeads}/>
                    </Paper>
                  </div>

                  {id && (
                    <div role="tabpanel" id="painel-3" aria-labelledby="aba-3" style={painel(3)}>
                        <Paper variant="outlined" style={{ padding: "18px 20px" }}>
                            <HistoricoAgendamentos leadId={id} />
                        </Paper>
                    </div>
                  )}
                </form>
            </Container>
    )
}


export default  FormCustomer;